export var TypeActionPlayerBase;
(function (TypeActionPlayerBase) {
    TypeActionPlayerBase["SelectBase"] = "PlayerBase > Select Base";
})(TypeActionPlayerBase || (TypeActionPlayerBase = {}));
export var actionPlayerBaseSelectBase = function (baseId) { return ({
    baseId: baseId,
    type: TypeActionPlayerBase.SelectBase,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/actionPlayerBase.ts
// module id = 561
// module chunks = 3